import { render, staticRenderFns } from "./RecommendedThreadsSection.vue?vue&type=template&id=3633d390&scoped=true&"
import script from "./RecommendedThreadsSection.vue?vue&type=script&lang=js&"
export * from "./RecommendedThreadsSection.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedThreadsSection.vue?vue&type=style&index=0&id=3633d390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3633d390",
  null
  
)

export default component.exports